import { FC, useState } from 'react'
import { SiteModel } from '../../../core/_models'
type Props = {
    site: SiteModel
}
const WasteWaterSewage: FC<Props> = ({ site }) => {

    var formattedDate = '';

    if (site.wasteWaterSewage != null || site.wasteWaterSewage != undefined) {
        formattedDate = site.wasteWaterSewage === '0001-01-01T00:00:00' ? '' : new Date(site.wasteWaterSewage).toLocaleDateString('tr-TR');
    }

    return (
        <div className='d-flex align-items-center'>
            {formattedDate}
        </div>
    )

}
export { WasteWaterSewage }
